import { render, staticRenderFns } from "./screen-4.vue?vue&type=template&id=baad1d4e&scoped=true&"
import script from "./screen-4.vue?vue&type=script&lang=js&"
export * from "./screen-4.vue?vue&type=script&lang=js&"
import style0 from "./screen-4.vue?vue&type=style&index=0&id=baad1d4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baad1d4e",
  null
  
)

export default component.exports